const deleteQuestionsStr = {
  toastrTrue: 'Deleted group',
  toastrFalse: 'Deleted question',
  txt: 'successfully deleted'
};

export default deleteQuestionsStr;
